import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ShieldCheck, Wallet, Store } from "lucide-react";
import { Button } from "./ui/button";

const NAV = [
  { label: "الرئيسية", to: "/" },
  { label: "الإعلانات", to: "/category/cars" },
  { label: "الخدمات الذكية", to: "/services" },
  { label: "البناء", to: "/build" },
  { label: "المتجر", to: "/marketplace" },
  { label: "المحفظة", to: "/wallet" },
  { label: "من نحن", to: "/about" },
];

const Logo = () => (
  <Link to="/" className="flex items-center gap-2.5 group">
    <span className="relative flex h-10 w-10 items-center justify-center rounded-xl brand-gradient text-sm font-extrabold text-[#052027] shadow-lg">
      A4
    </span>
    <span className="text-right leading-tight">
      <span className="block font-display text-lg font-extrabold tracking-tight">
        <span className="text-gold">AQL</span>
        <span className="text-cyan">4</span>
      </span>
      <span className="block text-[10px] text-muted-foreground">آقطار الخدمات الرقمية</span>
    </span>
  </Link>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "glass border-b border-white/5" : "bg-transparent"}`}>
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <Logo />

        <div className="hidden items-center gap-1 lg:flex">
          {NAV.map((l) => {
            const active = location.pathname === l.to;
            return (
              <Link key={l.to} to={l.to}
                className={`rounded-lg px-3.5 py-2 text-sm font-medium transition-colors ${active ? "text-white bg-white/5" : "text-muted-foreground hover:text-white hover:bg-white/5"}`}>
                {l.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden items-center gap-2 lg:flex">
          <Button onClick={() => navigate("/admin")} variant="outline"
            className="h-9 gap-2 rounded-lg border-white/15 bg-transparent px-3.5 text-sm text-white hover:bg-white/5 hover:text-white">
            <ShieldCheck className="h-4 w-4" /> الإدارة
          </Button>
          <Button onClick={() => navigate("/services")} className="btn-cyan h-9 gap-2 rounded-lg px-4 font-semibold hover:bg-transparent">
            الخدمات الذكية
          </Button>
        </div>

        <button className="rounded-lg p-2 text-white lg:hidden" onClick={() => setOpen((o) => !o)} aria-label="القائمة">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="glass border-t border-white/5 lg:hidden">
          <div className="flex flex-col gap-1 px-5 py-4">
            {NAV.map((l) => (
              <Link key={l.to} to={l.to} className="rounded-lg px-3 py-2.5 text-base font-medium text-muted-foreground hover:bg-white/5 hover:text-white">
                {l.label}
              </Link>
            ))}
            <div className="mt-3 grid grid-cols-2 gap-2">
              <Button onClick={() => navigate("/admin")} variant="outline" className="gap-2 rounded-lg border-white/15 bg-transparent text-white">
                <ShieldCheck className="h-4 w-4" /> الإدارة
              </Button>
              <Button onClick={() => navigate("/services")} className="btn-cyan rounded-lg font-semibold hover:bg-transparent">
                الخدمات
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
